(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
        $(".faqs-header").first().parent().addClass("active");
        $(".faqs-header").first().parent().find(".faqs-body").show();

        $(".faqs-header").click(function () {
            $(this).parent().find('.faqs-body').slideToggle();
            $(this).parent().toggleClass('active');

            $(".faqs-header").not(this).parent().find('.faqs-body').slideUp();
            $(".faqs-header").not(this).parent().removeClass('active');
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-me-decide"] && !Shopify.designMode) return;
  try {
    
 window.addEventListener('pageshow', function (event) {
  if (event.persisted || (performance.getEntriesByType("navigation")[0]?.type === "back_forward")) {
    console.log("User returned to the page using the back button or session was restored.");
    // You can trigger your logic here
    location.reload();
  } else {
    console.log("Page loaded normally.");
  }
});

// Modal open/close logic for static modals
document
  .querySelectorAll('.step-card-col[for="step3-quart"] .card-cta-link')
  .forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const modalId = this.getAttribute("data-openid");
      const modal = document.getElementById(modalId);

      // Show modal
      modal.style.display = "grid";

      // Stop body scroll
      document.body.style.overflow = "hidden";
    });
  });

// Close button click
document.querySelectorAll(".custom-modal-close").forEach((btn) => {
  btn.addEventListener("click", function () {
    const modal = document.getElementById(this.getAttribute("data-modal"));
    modal.style.display = "none";

    // Restore body scroll
    document.body.style.overflow = "";
  });
});

// Background click to close modal
document.querySelectorAll(".custom-modal-bg").forEach((bg) => {
  bg.addEventListener("click", function (e) {
    if (e.target === this) {
      this.style.display = "none";

      // Restore body scroll
      document.body.style.overflow = "";
    }
  });
});

// Accordion logic for all static modals
document.addEventListener("click", function (e) {
    if (e.target.classList.contains("accordion-toggle")) {
        const btn = e.target;
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", !expanded);
        btn.querySelector("span:last-child").innerHTML = !expanded
        ? "&#8722;"
        : "&#43;";
        const content = btn.nextElementSibling;
        if (content) content.style.display = !expanded ? "block" : "none";
    }
});

// Step form logic with radio inputs and slide animation
const totalSteps = 3;
const progressBar = document.querySelector(".progress-bar");
const stepWrappers = Array.from(
document.querySelectorAll(".help-step-wrapper")
);
const goBackBtns = document.querySelectorAll(".step-go-back-btn");
let currentStep = 0;

function showStep(stepIdx, direction = "up") {
    if (stepIdx === currentStep) return;
    const prevStep = currentStep;
    const prevWrapper = stepWrappers[prevStep];
    const nextWrapper = stepWrappers[stepIdx];
    
    // Remove all animation classes
    stepWrappers.forEach((w) => {
        w.classList.remove("fade-anim");
    });
    
    // Hide all
    stepWrappers.forEach((el, i) => {
        el.classList.remove("active");
    });
    
    // Animate next in with fade
    nextWrapper.classList.add("fade-anim");
    nextWrapper.classList.add("active");
    
    if(currentStep == 1){

      const selectedValue = document.querySelector('input[name="step1"]:checked')?.value;
      const selectedValue2 = document.querySelector('input[name="step2"]:checked')?.value;
      console.log("selectedValue"+selectedValue+"selectedValue2"+selectedValue2);
     document.querySelectorAll('.step-3 .step-card-col').forEach((el) => {
  el.style.display = "none";
  
});
 document.querySelectorAll('.step-3 .step-card-col .recommend-tag').forEach((el) => {
  el.style.display = "none";
  el.style.order = "5";
  el.closest('.step-card')?.classList.remove('active');
el.closest('.step-card-col')?.classList.remove('active');
});
 document.querySelectorAll('.step-3 .step-card-col .frequency').forEach((el) => {
  el.style.display = "none";
});
    // Show only elements that have both selected classes
    
    if(selectedValue == 'both'){
     document.querySelectorAll(`.step-3 .step-card-col.mix-${selectedValue2}`).forEach((el) => {
  el.style.display = "block";
});
document.querySelectorAll(`.mix-${selectedValue2}-recommended .recommend-tag`).forEach((el) => {
      el.style.display = "block";   
      
     el.closest('.step-card')?.classList.add('active');
     el.closest('.step-card-col')?.classList.add('active');

});
 document.querySelectorAll(`.mix-${selectedValue2}.frequency`).forEach((el) => {

      el.style.display = "block";      
     /******New codde*****************/  
      var parentCard = el.closest('.step-card-content');
      
  if (parentCard) {
    // Extract numeric value from inner HTML (e.g., "Delivery every 16 weeks" → 16)
   var recommendedValue =el.getAttribute('data-hreftag');
    
    parentCard.setAttribute(
      "onclick",
      `location.href='${recommendedValue}'`
    );
    parentCard.style.cursor = "pointer";
  }
   var parentCardnew = el.closest('.step-card');
      
  if (parentCardnew) {
    // Extract numeric value from inner HTML (e.g., "Delivery every 16 weeks" → 16)
   var recommendedValue =el.getAttribute('data-hreftag');
    
    parentCardnew.querySelector('img').setAttribute(
      "onclick",
      `location.href='${recommendedValue}'`
    );
    parentCard.style.cursor = "pointer";
  }
  /****************************/  
});
    }else{
      document.querySelectorAll(`.step-3 .step-card-col.${selectedValue}-${selectedValue2}`).forEach((el) => {
      el.style.display = "block"; el.style.display = "block";     
});
 document.querySelectorAll(`.${selectedValue}-${selectedValue2}-recommended .recommend-tag`).forEach((el) => {
      el.style.display = "block";   el.closest('.step-card')?.classList.add('active');  el.closest('.step-card-col')?.classList.add('active');  
});
 document.querySelectorAll(`.${selectedValue}-${selectedValue2}.frequency`).forEach((el) => {
      el.style.display = "block";    
            /******New codde*****************/  
      var parentCard = el.closest('.step-card-content');
      
  if (parentCard) {
    // Extract numeric value from inner HTML (e.g., "Delivery every 16 weeks" → 16)
   var recommendedValue =el.getAttribute('data-hreftag');
    
    parentCard.setAttribute(
      "onclick",
      `location.href='${recommendedValue}'`
    );
    parentCard.style.cursor = "pointer";
  }
   var parentCardnew = el.closest('.step-card');
      
  if (parentCardnew) {
    // Extract numeric value from inner HTML (e.g., "Delivery every 16 weeks" → 16)
   var recommendedValue =el.getAttribute('data-hreftag');
    
    parentCardnew.querySelector('img').setAttribute(
      "onclick",
      `location.href='${recommendedValue}'`
    );
    parentCard.style.cursor = "pointer";
  }
  /****************************/  
});
    }



    }
    // Progress bar
    const percent = ((stepIdx + 1) / 3) * 100;
    progressBar.style.width = percent + "%";
    
    // Remove animation class after animation
    setTimeout(() => {
        nextWrapper.classList.remove("fade-anim");
    }, 800);
    
    currentStep = stepIdx;
}

// Next step on radio select
stepWrappers.forEach((wrapper, idx) => {
    const radios = wrapper.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
        radio.addEventListener("change", function () {
            if (radio.checked && idx < totalSteps - 1) {
                showStep(idx + 1, "up");
            }
        });
    });
});

// Go Back button
goBackBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
        const currentIdx = stepWrappers.findIndex((w) =>
        w.classList.contains("active")
        );
        if (currentIdx > 0) {
            showStep(currentIdx - 1, "down");
        }
        console.log("currentIdx"+currentIdx);
        if(currentIdx==1){
          document.querySelectorAll('input[name="step1"]').forEach((radio) => {
  radio.checked = false;
});}
document.querySelectorAll('input[name="step2"]').forEach((radio) => {
  radio.checked = false;
});
        
    });
    
});

// Initialize first step
showStep(0);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
  const popup = document.createElement('div');
  popup.className = 'video-popup-overlay';
  popup.innerHTML = `
    <div class="video-popup-content">
      <span class="video-popup-close">&times;</span>
      <video controls autoplay playsinline></video>
    </div>
  `;
  document.body.appendChild(popup);

  const videoElement = popup.querySelector("video");
  const closeBtn = popup.querySelector(".video-popup-close");

  document.querySelectorAll(".open-video-popup").forEach(button => {
    button.addEventListener("click", function () {
      const videoUrl = this.getAttribute("data-video-url");

      videoElement.src = videoUrl;
      videoElement.load();

      videoElement.play().catch(error => {
        console.log("Autoplay failed:", error);
      });

      popup.classList.add("active");
    });
  });

  const closePopup = () => {
    videoElement.pause();
    videoElement.removeAttribute("src"); 
    videoElement.load();

    popup.classList.remove("active");
  };

  closeBtn.addEventListener("click", closePopup);

  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });
});



// hero video card
document.addEventListener("DOMContentLoaded", function() {
  const bigVideo = document.getElementById("hero-card-video");
  const video = bigVideo.querySelector(".video-element");

  video.addEventListener("click", function() {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
    // Testimonials slider
     $('.testimonials-slider').slick({
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4500,
        pauseOnHover: false
    });

    // video lightbox
    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

    const lightboxVideo = GLightbox({
        selector: '.glightbox-video',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

    lightbox.on('open', () => {
        document.querySelector('.glightbox-container').classList.remove('video-open');
    });

    lightboxVideo.on('open', () => {
        document.querySelector('.glightbox-container').classList.add('video-open');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-big"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const bigVideo = document.querySelector(".big-video");
  const video = bigVideo.querySelector(".video-element");
  const playIcon = bigVideo.querySelector(".vid-play-icon");

  bigVideo.addEventListener("click", function() {
    if (!bigVideo.classList.contains("active")) {
      bigVideo.classList.add("active");
      playIcon.style.display = "none";
      video.setAttribute("controls", "true");
      video.play();
    } else {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  });

  video.addEventListener("ended", function() {
    bigVideo.classList.remove("active");
    playIcon.style.display = "block";
    video.removeAttribute("controls");
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carosal"] && !Shopify.designMode) return;
  try {
    

    $('.video-carosal').slick({
        dots: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        responsive: [
            {
            breakpoint: 1679,
            settings: {
                slidesToShow: 4
            }
            },
            {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3
            }
            },
            {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
            },
            {
            breakpoint: 575,
            settings: {
                slidesToShow: 1
            }
            }
        ]
    });

  } catch(e) { console.error(e); }
})();
})();
